import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from 'react-router-dom';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Grid } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, Typography } from "@mui/material";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { PRIMARY, WHITE } from "../styles/color";
import allProducts from "../Images/allProduct.png";
import ProductCard from "../components/ProuctCard";
import offerImage from "../Images/%off.png";
import { useDispatch, useSelector } from "react-redux";
import API_URL from "../ServiceModule/Service";
import axios from "axios";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../Api/api";
import "../Shop/CSS/shop.css";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
} from "../Features/services/cartSlice";
import { ADD_TO_CART, REMOVE_FROM_CART } from "../Api/apiConstant";
import debounce from "lodash.debounce";
import { CircularProgress } from "@material-ui/core";
import { useThemeColors } from "../Context/Theme";
import { renderPagination } from "../Utils/Pagination";
import { toast, ToastContainer } from "react-toastify";
import { getLoggedIn, getToken, getUserId } from "../LoginModule/LoginUtility";


const useStyles = makeStyles((theme) => ({
  customBg: {
    backgroundColor: "#F5F6FA",
  },
  customButton: {
    backgroundColor: "#E1FCF3",
    color: "#07E098",
    height: "9%",
    width: "130px !important",
    minWidth: "130px",
    padding: "0",
    textAlign: "center",
  },
  select: {
    padding: "4px 12px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "16px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
}));

const Search = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
    fontWeight,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading,
  } = useThemeColors();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortValue, setSortValue] = useState("Newest");
  const location = useLocation();

  const eventId = sessionStorage.getItem("event_id");
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [productData, setProductData] = useState([]);
  const [allProduct, setAllProduct] = useState([]);

  const [selectedSku, setSelectedSku] = useState({});
  const [selectedSkuid, setSelectedSkuid] = useState({});
  const [page, setPage] = useState(1);
  const eventName = sessionStorage.getItem("eventName");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { results, selectedOption } = location.state || {};
  const [searchResults, setSearchResults] = useState([]);


  useEffect(() => {
    if (results) {
      setSearchResults(results);
    }
  }, [results]);
  const {
    data: categories,
    isError,
    isLoading,
    isSuccess,
  } = useGetAPIWithoutTokenQuery(
    `/api/category/readAllCategories?event_id=${eventId}&type=category&page=1&limit=10000`, { refetchOnMountOrArgChange: true, skip: !eventId }
  );

  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();
  const [Removecart] = useRemoveFromCartWithTokenMutation();

  const userId = getUserId()
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const isLoggedIn = getLoggedIn()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const ITEMS_PER_PAGE = 15000;
  const offerData = useSelector((state) => state.offer.value);
  const cartItem = useSelector((state) => state.cart.items);
  const bottomRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const [selectedSkuQuantity, setSelctedSkuQuantity] = useState([])



  useEffect(() => {
    scrollToTop();
  }, []);

  const scrollToTop = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (location.state && location.state.category) {
      setSelectedCategory(location.state.category);
    }
  }, [location.state]);

  const {
    data: AllProductData,
    isSuccess: AllProductSuccess,
    isError: AllProductError,
    isLoading: AllProductLoading,
  } = useGetAPIWithoutTokenQuery(
    `/api/product/readAllProducts?event_id=${eventId}&page=${page}&limit=${ITEMS_PER_PAGE}&search=${searchResults}`, { refetchOnMountOrArgChange: true, skip: !eventId }
  );

  useEffect(() => {
    if (AllProductSuccess && !AllProductError && !AllProductLoading) {
      setAllProduct(AllProductData.data);
      setProductData(AllProductData.data);
    }
  }, [AllProductData, AllProductError, AllProductLoading, AllProductSuccess]);


  const totalPages = Math.ceil(selectedCategory === "all" ? AllProductData?.pagination?.totalRecords / ITEMS_PER_PAGE : productData?.length / ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    setPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  useEffect(() => {
    if (eventId && selectedCategory !== null) {
      if (selectedCategory === "all") {
        setProductData(allProduct);
      } else {
        const fetchProducts = async () => {

          try {
            const response = await axios.get(
              `${API_URL}/api/product/getEventById?event_id=${eventId}&category_id=${selectedCategory}`
            );
            if (
              response.data.status === "false" ||
              response.data.message === "no products found"
            ) {
              setProductData([]);

            } else {

              setProductData(response?.data?.data);
            }
          } catch (err) {
            setProductData([]);
            console.error("No products found:", err.response.data);
          }
        };
        fetchProducts();
      }
    }
  }, [eventId, selectedCategory, allProduct, setProductData]);



  const sortProductsByDiscountPrice = (order) => {
    if (!productData) return;

    const sortedProducts = [...productData].sort((a, b) => {
      const priceA = a.skus[0].discount_price || a.skus[0].regular_price;
      const priceB = b.skus[0].discount_price || b.skus[0].regular_price;
      return order === "asc" ? priceA - priceB : priceB - priceA;
    });

    setProductData(sortedProducts);

  };

  const handleSortChange = (event) => {
    const value = event.target.value;

    setSortValue(value);

    if (value === "Price Ac") {
      sortProductsByDiscountPrice("asc");
    } else if (value === "Price Dc") {
      sortProductsByDiscountPrice("desc");
    } else if (value === "all") {
      setProductData(AllProductData.data);
      setSelectedCategory("all");
    }
  };

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
    setSortValue("");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku((prevSelectedSku) => ({
          ...prevSelectedSku,
          [product.product_id]: selectedSku,
        }));
      }
    } catch (error) {

    }
  };

  const handleChangeQuantity = async (value, product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (!value) {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(prev => [...prev, selectedSkuData.sku_id])
      handleRemoveFromCart(product, 0);
      return;
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    // Create the new cart item with the desired structure
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    setSelctedSkuQuantity(prev => {
      // Remove any previous entries with the same skuId
      const filtered = prev.filter(item => item.skuId !== selectedSkuData.sku_id);
      // Add the new one at the end
      return [...filtered, { skuId: selectedSkuData.sku_id, quantity: value }];
    });
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };
    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      // Update quantity and total price for an existing item
      newCartItem.quantity = value;
      newCartItem.total_price = (newCartItem.quantity * parseFloat(newCartItem.price)).toFixed(2);
    }

    // Redirect to login if the user is not logged in
    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // Dispatch the new cart item to Redux store
      // dispatch(
      //   addToCart({
      //     ...newCartItem,
      //   })
      // );
      // Make API call to add the item to the backend cart
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data?.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  }

  const handleAddToCart = async (product) => {
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];

    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity:
        selectedSkuData?.quantity > 0 ? selectedSkuData?.quantity + 1 : 1,
      price:
        selectedSkuData?.discount_price > 0
          ? selectedSkuData?.discount_price
          : selectedSkuData?.regular_price,
    };

    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      newCartItem.quantity = existingCartItem.quantity + 1;
    }

    if (isLoggedIn) {
      // dispatch(addToCart({ ...product, quantity: newCartItem.quantity }));
      try {
        const { data } = await AddToCart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
          },
          token: token,
        });

        if (data.message === "Cart and CartItems processed successfully") {
          sessionStorage.setItem("cartId", data?.cart_id);
        }
      } catch (error) {

      }
    } else {
      navigate(`/events/${eventName}/login`);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const selectedSkuData = selectedSku[product.product_id]
    const existingCartItem = cartItem?.find(
      (item) =>
        item.product_id === product?.product_id &&
        item.sku_id === selectedSkuData?.sku_id
    );
    const newCartItem = {
      product_id: existingCartItem?.product_id,
      sku_id: existingCartItem?.sku_id,
      bundle_id: existingCartItem?.bundle_id,
      quantity: value ? value : existingCartItem?.quantity > 1 ? existingCartItem?.quantity - 1 : 0,
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price > 0
          ? existingCartItem?.product_details?.skus[0]?.discount_price
          : existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      if (existingCartItem && existingCartItem?.quantity > 1 && !value) {
        const previousQuantity = existingCartItem?.quantity;
        const newQuantity = previousQuantity - 1;
        // dispatch(removeFromCart({ ...product, quantity: newQuantity }));

        const { data } = await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove'
          },
          token: token,
        });
      } else if (value == 0 || (existingCartItem && existingCartItem?.quantity === 1)) {
        // dispatch(removeItemFromCart({ itemId: existingCartItem?.product_id }));
        const { data } = await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem?.product_id,
            sku_id: existingCartItem?.sku_id,
          },
          token: token,
        });
      }
    } catch (error) {

    }
  };

  const debouncedAddToCart = debounce(handleAddToCart, 300);
  const debouncedRemoveFromCart = debounce(handleRemoveFromCart, 300);

  const selectedCategoryName =
    selectedCategory === 'all'
      ? 'All Products'
      : categories?.data?.find(
        (category) => category.category_id === selectedCategory
      )?.category_name;



  // const breadcrumbs = [
  //   <Link
  //     to={`/events/${eventName}`}
  //     className="text-decoration-none font-size text-secondary"
  //     style={{ fontSize: isMobile ? "12px" : "17px", fontFamily }}
  //     underline="hover"
  //     key="1"
  //     color="inherit"
  //     href="/"
  //   >
  //     Home
  //   </Link>,
  //   <Link
  //     className="text-decoration-none font-size text-secondary"
  //     style={{ fontSize: isMobile ? "12px" : "17px", fontFamily }}
  //     underline="hover"
  //     key="1"
  //     color="inherit"
  //     href="/"
  //   >
  //     Search Results
  //   </Link>
  // ];

  const CategoryList = ({ categories, selectedCategory, handleCategoryClick, primaryColor, textColor, allProducts }) => (
    <List component="nav" style={{ maxHeight: "135vh", overflowY: "auto", scrollbarWidth: "thin" }}>
      {[{ category_id: "all", category_img_path: allProducts, category_name: "All Products" }, ...categories?.data].map((item, index) => (
        <ListItemButton
          key={index}
          selected={selectedCategory === item.category_id}
          onClick={() => handleCategoryClick(item.category_id)}
          style={{
            backgroundColor: selectedCategory === item.category_id ? `rgba(${parseInt(primaryColor?.substring(1, 3), 16)}, ${parseInt(primaryColor?.substring(3, 5), 16)}, ${parseInt(primaryColor?.substring(5, 7), 16)}, 0.5)` : "white",
            color: selectedCategory === item.category_id ? textColor : "black",
            borderLeft: selectedCategory === item.category_id ? `6px solid ${primaryColor}` : "none",
          }}
        >
          <img style={{ width: "15%", height: "6vh", objectFit: "contain" }} src={item.category_img_path} alt={item.category_name} />
          <ListItemText primary={item.category_name} sx={{ fontWeight: 500, fontSize: "13px", lineHeight: "20px", padding: "0.8em" }} />
        </ListItemButton>
      ))}
    </List>
  );

  const ProductGrid = ({ searchResults, debouncedAddToCart, debouncedRemoveFromCart, handleUnitSelect, offerImage }) => (
    <Grid container spacing={2}>
      {searchResults?.length > 0 ? (
        searchResults.map((product) => (
          <Grid item xs={12} sm={6} md={3} key={product.id} style={{ position: "relative" }}>
            <ProductCard
              product={product}
              image={product?.productImg?.[0]?.product_img}
              buttonText="ADD"
              onClick={() => debouncedAddToCart(product)}
              addQuantity={() => debouncedAddToCart(product)}
              removeQuantity={() => debouncedRemoveFromCart(product)}
              onUnitSelect={(prod, skuID) => handleUnitSelect(prod, skuID)}
              offerImage={offerImage}
              handleChangeQuantity={handleChangeQuantity}
              blankQuantitySku={blankQuantitySku}
              selectedSkuQuantity={selectedSkuQuantity}
            />
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="h6" style={{ textAlign: "center", padding: "20px 0", color: "red" }}>No products found</Typography>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <ToastContainer autoClose={2000} />
      <Navbar className="sticky-navbar" />
      {AllProductLoading ? (
        <div className="loading-container"><CircularProgress color="secondary" /></div>
      ) : (
        <div className="content-container" style={{ background: backgroundColor || "#FAFAFA", marginTop: "15vh" }}>
          <Grid container spacing={4} className="mb-3 breadcrumb-container">
            <Grid item xs={12} md={6}><Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>{breadcrumbs}</Breadcrumbs></Grid>
            <Grid item xs={12} md={6} className="sort-container">
              <Typography variant="body1" component="span" className="sort-label">Sort By</Typography>
              <select id="sortSelect" className="shortContainer" value={sortValue} onChange={handleSortChange}>
                <option value="all">Relevance</option>
                <option value="Price Ac">Price (Low to High)</option>
                <option value="Price Dc">Price (High to Low)</option>
              </select>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="main-grid">
            <Grid item xs={3} className="category-list-container">
              <CategoryList categories={categories} selectedCategory={selectedCategory} handleCategoryClick={handleCategoryClick} primaryColor={primaryColor} textColor={textColor} allProducts={allProducts} />
            </Grid>
            <Grid item xs={9} className="product-grid-container">
              <ProductGrid searchResults={searchResults} debouncedAddToCart={debouncedAddToCart} debouncedRemoveFromCart={debouncedRemoveFromCart} handleUnitSelect={handleUnitSelect} offerImage={offerImage} />
              {totalPages > 1 && <div className="pagination-container">{renderPagination({ page, totalPages, handlePageChange })}</div>}
            </Grid>
          </Grid>
          <Footer />
        </div>
      )}
    </>
  );
};

export default Search;
